import { OnInit, ViewChild, Component } from '@angular/core';
import { MatTableDataSource, MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';import { StudyReportTemplateFilter } from 'src/app/model/study-report-template-filter';
import { SearchFilter, IFilterResponse } from 'src/app/infrastructure/iFilter-component';
import { SearchFilterComponent } from '../../search-filter/search-filter.component';
import { PagerControlComponent } from '../../controls/pager/pager-control.component';
import { MenuService } from 'src/app/services/menu.service';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { StudyReportService } from '../../../services/study-report/study-report.service';
import { SelectionModel } from '@angular/cdk/collections';
import { OtherAdmissionMedicalAppointmenDialogComponent } from '../../dialogs/other-admission-medical-appointment/other-admission-medical-appointment-dialog.component';
import { PhysiciansDialogComponent } from '../../dialogs/physicians-dialog/physicians-dialog.component';

@Component({
  selector: 'app-study-report-template-search',
  templateUrl: './study-report-template-search.component.html'
})
export class StudyReportTemplateSearchComponent implements OnInit {

  loadingMasiveAction: boolean;
  loadingAction: boolean;
  loading: boolean;
  studyReportTemplateFilters: StudyReportTemplateFilter[] = [];
  searchFilters: SearchFilter[];
  displayedColumns: string[] = ['Select', 'Name', 'Star'];
  dataSource = new MatTableDataSource([]);
  selection = new SelectionModel<StudyReportTemplateFilter>(true, []);
  @ViewChild('searchFilter', {static: false}) searchFilter: SearchFilterComponent;
  @ViewChild('pager', {static: true}) pager: PagerControlComponent;
  editorId: number;

  constructor(public dialog: MatDialog
    , private route: ActivatedRoute
    , private router: Router
    , private notificationToastService: NotificationToastService
    , private studyReportService: StudyReportService
    , private menuService: MenuService) {
    this.menuService.setMenuTitle('Plantillas', 'Búsqueda');
  }

  ngOnInit(): void {

     this.route.params.subscribe(async (params) => {
        this.editorId = params["editorId"];
    })
  }

  isAllSelected() {
    if (this.selection.selected && this.pager.getAllItems()) {
      const numSelected = this.selection.selected.length;
      const numRows = this.pager.getAllItems().length;
      return numSelected === numRows;
    } else {
      return false;
    }
  }

  async assignToProfessional()  {
    const dialogRef = this.dialog.open(PhysiciansDialogComponent, {
      width: '50%',
    });
    const result = await dialogRef.afterClosed().toPromise();
    if ( result ) {
      try {
        this.loadingMasiveAction = true;
        await this.studyReportService
        .studyReportTemplateAssignToProfessional(this.selection.selected.map(s => s.Id), result );
        this.notificationToastService.success('Se asignaron las plantillas correctamente', 'Plantillas');
      } catch (err) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Plantillas');
      } finally {
        this.loadingMasiveAction = false;
      }
    }
  }

  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.pager.getAllItems().forEach(row => this.selection.select(row));
  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
    this.loading = false;
  }

  isSomeSelected() {
    return this.selection.selected.length > 0;
  }

  addNew(): void {
    this.router.navigate(['study-report-template-edit', this.editorId]);
  }

  edit(studyReportTemplateFilter: StudyReportTemplateFilter): void {
    this.router.navigate(['study-report-template-edit', this.editorId, studyReportTemplateFilter.Id]);
  }

  async delete(studyReportTemplateFilter: StudyReportTemplateFilter) {
    try {
      this.loadingAction = true;
      await this.studyReportService.studyReportTemplateDelete(studyReportTemplateFilter);
      await this.searchFilter.search();
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Plantillas');
    } finally {
      this.loadingAction = false;
    }
  }

  async enable(studyReportTemplateFilter: StudyReportTemplateFilter) {
    try {
      this.loadingAction = true;
      await this.studyReportService.studyReportTemplateEnable(studyReportTemplateFilter);
      await this.searchFilter.search();
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Plantillas');
    } finally {
      this.loadingAction = false;
    }
  }

  onEndSearch(response: IFilterResponse<StudyReportTemplateFilter>) {
    this.studyReportTemplateFilters = response.items;
    this.searchFilters = response.searchFilters;
    this.pager.setItems(this.studyReportTemplateFilters);
  }

  onStartSearch() {
    this.loading = true;
  }
}
